import React, { useState, useEffect } from "react";
import { FiHome, FiChevronRight, } from "react-icons/fi";
import { Link, } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getHoliday, } from "../../store/slices/holiday";
import { toast } from "react-hot-toast";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";

const localizer = momentLocalizer(moment);

export default function TeacherHoliday() {
  const dispatch = useDispatch();

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);


  const fetchHoliday = () => {
    setIsLoading(true);

    dispatch(getHoliday())
      .unwrap()
      .then((res) => {
        const notices = res?.data || [];
        setData(notices);
      })
      .catch(({ message }) => {
        console.error(message);
        toast.error("Failed to fetch Holiday details ")
        setData([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchHoliday();
  }, []);

  const events = data.map((holiday) => ({
    id: holiday._id,
    title: holiday.name,
    start: new Date(holiday.fromDate),
    end: new Date(
      new Date(holiday.toDate).setDate(
        new Date(holiday.toDate).getDate() + 1
      )
    ),
    allDay: true,
  }));


  const eventStyleGetter = () => ({
    style: {
      background: "linear-gradient(135deg,#8451ff,#6f7cff)",
      color: "#fff",
      border: "none",
      borderRadius: "20px",
      fontWeight: 600,
      fontSize: "12px",
      padding: "4px 8px",
      boxShadow: "0 3px 10px rgba(132,81,255,.25)",
    },
  });

  const CustomToolbar = ({ label, onNavigate }) => (
    <div className="holiday-toolbar">
      <button onClick={() => onNavigate("PREV")}>
        ❮
      </button>

      <h3>{label}</h3>

      <div className="toolbar-actions">
        <button onClick={() => onNavigate("TODAY")}>
          Today
        </button>

        <button onClick={() => onNavigate("NEXT")}>
          ❯
        </button>
      </div>
    </div>
  );

  const handleSelectEvent = (event) => {
    toast.success(
      `${event.title}

${moment(event.start).format("DD MMM YYYY")} - ${moment(event.end)
        .subtract(1, "day")
        .format("DD MMM YYYY")}`
    );
  };
  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">


          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/teacher/home">
                <FiHome style={{ color: "white", marginTop: "-4px" }} />
              </Link>
            </div>

            <FiChevronRight className="separator" />
            <span className="active">Holiday</span>
          </div>

          <div className="d-flex align-items-center gap-2 flex-wrap">
          </div>

        </div>
      </div>
      <div className="staff-card">

        <div
          style={{
            height: "700px",
            background: "#fff",
            borderRadius: "12px",
            padding: "20px",
          }}
        >
          <Calendar
            localizer={localizer}
            events={events}
            startAccessor="start"
            endAccessor="end"
            defaultView="month"
            views={["month"]}
            popup
            components={{
              toolbar: CustomToolbar,
            }}
            eventPropGetter={eventStyleGetter}
            onSelectEvent={handleSelectEvent}
          />
        </div>

      </div>
    </>
  );
}
